(() => {
    const categoryCarousels = () => {
        const carousels = document.querySelectorAll('.diensa-carousel .swiper');
    
        if (!carousels.length) return;
        
        carousels.forEach(carousel => {
            const carouselType = carousel.getAttribute('data-collection');

            const nextEl = document.querySelector('.button-next[data-collection="' + carouselType + '"]');
            const prevEl = document.querySelector('.button-prev[data-collection="' + carouselType + '"]');

            const swiper = new Swiper(carousel, {
                loop: true,
                draggable: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    640: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                    1200: {
                        slidesPerView: 4,
                    }
                },
            });

            prevEl.addEventListener('click', () => {
                swiper.slidePrev();
              });
  
            nextEl.addEventListener('click', () => {
                swiper.slideNext();
            });


        });

        carousels.forEach(carousel => {
            const slides = carousel.querySelectorAll('.swiper-slide');

            if (!slides.length) return;

            if (slides.length < 5) {
                carousel.closest(".diensa-carousel").querySelector('.button-prev').style.display = 'none';
                carousel.closest(".diensa-carousel").querySelector('.button-next').style.display = 'none';
            }
            // let maxHeight = 0;

            // slides.forEach(slide => {
            //     if (slide.offsetHeight > maxHeight) {
            //         maxHeight = slide.offsetHeight;
            //     }
            // });

            // slides.forEach(slide => {
            //     slide.style.height = maxHeight + 'px';
            // });
        });
    }

    categoryCarousels();
})()